import { Link, ModalDrawer, useModalState } from '@egw/components'
import { configClient } from '@egw/config'
import { Trans, useTranslation } from '@egw/i18n'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'
import { type FC } from 'react'
import { type Config } from '../../../config/config'

export const AboutWiresModal: FC = () => {
  const { t } = useTranslation('features-transfer')
  const { isOpen, openModal, closeModal } = useModalState()
  const { zendeskArticles } = configClient.getConfig() as Config

  const discLiClass = cn('flex flex-row typo-primary-base-regular text-text-meta ml-2xs')

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="text-left text-text-action typo-primary-base-semibold w-fit flex flex-row gap-3xs mb-lg"
      >
        {t('wire_transfer.about_wires')}
        <InformationCircleIcon className="w-5 h-5 text-text-action self-center" />
      </button>

      <ModalDrawer title={t('tabbed_wire_transfer.about_wires_modal.title')} onClose={closeModal} isOpen={isOpen}>
        {/* <AboutWireTransfers hideCta /> */}
        <div className="flex flex-col gap-lg">
          <div className="flex flex-col gap-3">
            <p className="text-text-body typo-primary-md-semibold">
              {t('tabbed_wire_transfer.about_wires_modal.benefits')}
            </p>
            <ul className="list-inside list-disc leading-5">
              <div className={discLiClass}>
                <li />
                {t('tabbed_wire_transfer.about_wires_modal.benefits_li_1')}
              </div>
              <div className={discLiClass}>
                <li />
                {t('tabbed_wire_transfer.about_wires_modal.benefits_li_2')}
              </div>
              <div className={discLiClass}>
                <li />
                {t('tabbed_wire_transfer.about_wires_modal.benefits_li_3')}
              </div>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <p className="text-text-body typo-primary-md-semibold">
              {t('tabbed_wire_transfer.about_wires_modal.what_you_need')}
            </p>
            <ul className="list-inside list-disc leading-5">
              <div className={discLiClass}>
                <li />
                {t('tabbed_wire_transfer.about_wires_modal.what_you_need_li_1')}
              </div>
              <div className={discLiClass}>
                <li />
                {t('tabbed_wire_transfer.about_wires_modal.what_you_need_li_2')}
              </div>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <p className="text-text-body typo-primary-md-semibold">
              {t('tabbed_wire_transfer.about_wires_modal.process')}
            </p>
            <ul className="list-inside list-decimal leading-5">
              <div className={discLiClass}>
                <li className="mr-2xs" />
                {t('tabbed_wire_transfer.about_wires_modal.process_li_1')}
              </div>
              <div className={discLiClass}>
                <li className="mr-2xs" />
                {t('tabbed_wire_transfer.about_wires_modal.process_li_2')}
              </div>
              <div className={discLiClass}>
                <li className="mr-2xs" />
                {t('tabbed_wire_transfer.about_wires_modal.process_li_3')}
              </div>
              <div className={discLiClass}>
                <li className="mr-2xs" />
                {t('tabbed_wire_transfer.about_wires_modal.process_li_4')}
              </div>
            </ul>
          </div>

          <div className="text-meta text-sm flex flex-row gap-1">
            <Trans t={t} i18nKey="wire_transfer.client_service">
              <Link
                id="faqs"
                className="text-action font-semibold group content-evenly"
                href={zendeskArticles.wireTransferFundsFAQ}
              >
                {t('help_center.faqs')}
              </Link>
            </Trans>
          </div>
        </div>
      </ModalDrawer>
    </>
  )
}
